import { format, isToday } from "date-fns";
import { TFunction } from "i18next";

import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";
import { LanguageType } from "@/translations";

export function formatClientSmartSearchDate(date: Date, t: TFunction, language: LanguageType) {
  const time = format(date, "HH:mm", { locale: locales[language] });
  const uhr = t("common.clock");

  if (isToday(date)) {
    return `${t("layout.header.clientSmartSearch.today")} ${time} ${uhr}`;
  }

  const dateStr = format(date, "dd.MM.yyyy", { locale: locales[language] });
  return `${dateStr} ${time} ${uhr}`;
}
